import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { FilterProvider } from 'contexts/filter';
import { ErrorProvider } from 'contexts/error';
import { InfoProvider } from 'contexts/info';
import { SpaceProvider } from 'contexts/space';
import { ThemeModeProvider } from 'contexts/theme';
import { LocaleProvider } from 'contexts/locale';
import { ModalProvider } from 'contexts/modal';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import IntlWrapper from 'components/wrappers/intl';
import ApolloWrapper from 'components/wrappers/apollo';
import theme from 'theme';
import router from 'routes';

const App = () => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <ThemeModeProvider>
          <LocaleProvider>
            <CssBaseline />
            <IntlWrapper>
              <ApolloWrapper apiUrl={import.meta.env.VITE_GRAPHQL_SERVER_URL}>
                <SpaceProvider>
                  <FilterProvider>
                    <ErrorProvider>
                      <InfoProvider>
                        <ModalProvider>
                          <RouterProvider router={router} />
                        </ModalProvider>
                      </InfoProvider>
                    </ErrorProvider>
                  </FilterProvider>
                </SpaceProvider>
              </ApolloWrapper>
            </IntlWrapper>
          </LocaleProvider>
        </ThemeModeProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
